export default {
  "UNKNOWN": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur. Veuillez réessayer ou contacter l'administrateur."])},
  "APP_ERROR": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'application semble rencontrer quelques problèmes.<br />Veuillez réessayer plus tard ou contacter l'administrateur."])},
  "NOT_FOUND": {
    "PAGE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page introuvable"])},
    "WORKOUT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Séance introuvable"])}
  },
  "SOMETHING_WRONG": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite"])}
}